
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionSoftware = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionSoftwareTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionSoftwareTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionSoftware;